export enum AssetSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  Thumb = 'thumb'
}
